<template>
  <article class="goods-info-card" :class="{ 'is-sold-out': isSoldOut }">
    <!-- 占山头 / 电子围栏：按原列表结构展示，覆盖在商品卡最上层 -->
    <div
      v-if="showFence"
      class="fence_goods"
      :style="{ backgroundImage: 'url(' + activityImages.fence + ')' }"
      @click.stop="handlePreemptDetail"
    ></div>
<!--    <div v-if="showFence" class="fence_goods_base" @click.stop="handlePreemptDetail">-->
<!--      {{ fenceBase }}-->
<!--    </div>-->

    <!-- 玩乐豆：按原列表结构展示 -->
<!--    <div-->
<!--      v-if="showHappyBean"-->
<!--      class="happy_bean_goods"-->
<!--      :style="{ backgroundImage: 'url(' + activityImages.happyBean + ')' }"-->
<!--      @click.stop="handleDetail"-->
<!--    ></div>-->
<!--    <div v-if="showHappyBean" class="happy_bean_num" @click.stop="handleDetail">-->
<!--      {{ happyBean }}-->
<!--    </div>-->

    <div class="goods-card-main">
      <!-- 换购 / 特价 图片标签：放在卡片顶部原促销标签位置 -->
      <div class="activity-image-tags">
        <img
          v-if="showSwapImageTag"
          class="activity-image-tag tag-swap"
          :src="activityImages.swap"
          alt="换购"
        />
        <img
          v-if="showSpecialImageTag"
          class="activity-image-tag tag-special"
          :src="activityImages.special"
          alt="特价"
        />
      </div>

      <button
        v-if="showFavorite"
        class="favorite-btn"
        :class="{ active: localFavorite }"
        type="button"
        aria-label="收藏商品"
        @click.stop="handleFavorite"
      >
        {{ localFavorite ? '♥' : '♡' }}
      </button>

      <div class="goods-image" @click="handleDetail">
        <img v-if="imageUrl" :src="imageUrl" :alt="goodsName" @error="onImageError" />
        <div v-else class="goods-image-placeholder">
          <span>商品图</span>
        </div>

        <div v-if="showRetailProfit" class="retail-profit-bar">
          <span>零售价：¥{{ formatMoney(retailPrice) }}</span>
          <span>毛利率：{{ grossMargin }}%</span>
        </div>

        <div v-if="showSoldOutMask" class="soldout-mask">
          <img src="/static/img/goodsList/good_none_min.png" alt="">
        </div>
      </div>

      <div class="price-row">
        <template v-if="handPrice">
          <span class="hand-price-line">
            <span class="hand-price-label">到手约</span>
            <span class="hand-price-value">
              <small>¥</small>{{ formatMoney(handPrice) }}
            </span>
            <span class="hand-price-unit">/{{ unit }}</span>
          </span>
        </template>
        <template v-else>
          <span class="price">
            <small>¥</small>{{ formatMoney(displayPrice) }}
          </span>
          <span class="unit">/{{ unit }}</span>
        </template>
        <span v-if="originalPrice && originalPrice > (handPrice || displayPrice)" class="old-price">
          ¥{{ formatMoney(originalPrice) }}
        </span>
      </div>

      <h3 class="goods-name" :title="goodsName" @click="handleDetail">
        {{ goodsName }}
      </h3>

      <div v-if="showDrugTags && drugTags.length" class="drug-tags">
        <span v-for="tag in drugTags" :key="tag.text" class="drug-tag" :class="tag.type">
          {{ tag.text }}
        </span>
      </div>

      <p class="manufacturer" :title="manufacturer">{{ manufacturer || '-' }}</p>
      <p class="spec" :title="specification">规格：{{ specification || '-' }}</p>

      <div v-if="showStockInfo" class="meta-block">
        <div class="meta-row">
          <span :style="shouldHighlightExpiration(expirationDate) ? 'color:red' : 'color:black'">效期：{{ expirationDate || '-' }}</span>
          <span>件装量：{{ jianzhuang || '-' }}</span>
        </div>
        <div class="meta-row">
          <span>库存：{{ stockText }}</span>
          <span>中包装：{{ packages || '-' }}</span>
        </div>
      </div>

      <div v-if="showLimitInfo" class="limit-row">
        <span v-if="limit > 0">{{ limitLabel }}限购：{{ limit }}</span>
        <span v-if="promoLimit > 0">特价限购：{{ promoLimit }}</span>
      </div>

      <!-- 卡片上直接展示活动标签，弹窗只放详细活动信息 -->
      <div v-if="showCardActivityTags && cardActivityTags.length" class="card-activity-tags">
        <span
          v-for="tag in cardActivityTags"
          :key="tag.text"
          class="card-activity-tag"
          :class="tag.type"
        >
          {{ tag.text }}
        </span>
      </div>

      <div v-if="hasSpecialPriceActivity && ladderMessages.length" class="ladder-info-on-card">
        <p v-for="(line, index) in ladderMessages" :key="'ladder-' + index">{{ line }}</p>
      </div>

      <div class="operation-row">
        <div class="qty-control">
          <button type="button" @click.stop="reduceQuantity">−</button>
          <input
            :value="localQuantity"
            type="number"
            :min="minBuy"
            :max="maxQuantity"
            @wheel.prevent
            @input="onQuantityInput"
            @blur="validateQuantity"
          />
          <button type="button" @click.stop="addQuantity">+</button>
        </div>
        <button class="cart-btn" type="button" :disabled="cartDisabled" @click.stop="handleAddCart">
          {{ cartDisabled ? '暂不可买' : '加入购物车' }}
        </button>
      </div>
    </div>

    <div v-if="activityDetails.length" class="activity-popover">
      <div class="popover-title">活动详细信息</div>
      <section v-for="group in activityDetails" :key="group.title" class="popover-section">
        <h4>{{ group.title }}</h4>
        <p v-for="(line, index) in group.lines" :key="index" >{{ line }}</p>
      </section>
    </div>
  </article>
</template>

<script>
import swapTagImg from './assets/swap.png'
import specialTagImg from './assets/special.png'


const DEFAULT_LABEL_SET = {
  0: '',
  1: '特价',
  2: '赠送',
  3: '换购',
  4: '效期',
  5: '阶梯',
  6: '控销',
  7: '满赠',
  8: '秒杀',
  9: '会员'
}

const DEFAULT_VISIBLE = {
  swapImageTag: true,
  specialImageTag: true,
  favorite: true,
  happyBean: true,
  fence: true,
  retailProfit: true,
  drugTags: true,
  stockInfo: true,
  limitInfo: true,
  cardActivityTags: true,
  commonBuy: true,
  soldOutMask: true,
  ladderDetail: true,
  swapDetail: true,
  freeGiftDetail: true,
  seckillDetail: true
}
function toNumber(value, fallback) {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : fallback
}

function asArray(value) {
  if (!value) return []
  if (Array.isArray(value)) return value.filter(Boolean)
  if (typeof value === 'string') return value.split(',').map((item) => item.trim()).filter(Boolean)
  return []
}

export default {
  name: 'GoodsInfoCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    activityVisible: {
      type: Object,
      default: function () {
        return {}
      }
    },
    goodsLabelSet: {
      type: Object,
      default: function () {
        return DEFAULT_LABEL_SET
      }
    },
    imageFallback: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      localQuantity: 1,
      localFavorite: false,
      brokenImage: false,
      activityImages: {
        swap: swapTagImg,
        special: specialTagImg,
        happyBean: '/static/img/new/haapy_bean_bg.png',
        fence: '/static/img/new/zst_bk.png'
      }
    }
  },
  computed: {
    visible: function () {
      return Object.assign({}, DEFAULT_VISIBLE, this.activityVisible || {})
    },
    goodsId: function () {
      return this.item.goods_id || this.item.goodsId || this.item.id || ''
    },
    goodsName: function () {
      return this.item.goods_name || this.item.goodsName || this.item.name || '商品名称'
    },
    manufacturer: function () {
      return this.item.manufacturer_name || this.item.manufacturer || '-'
    },
    specification: function () {
      return this.item.specification || this.item.spec || '-'
    },
    unit: function () {
      return this.item.unit || '盒'
    },
    imageUrl: function () {
      if (this.brokenImage) return this.imageFallback
      return this.item.goods_img || this.item.goodsImg || this.item.image || this.imageFallback
    },
    displayPrice: function () {
      return toNumber(this.item.selling_price || this.item.sellingPrice || this.item.price, 0)
    },
    originalPrice: function () {
      return toNumber(this.item.original_price || this.item.originalPrice, 0)
    },
    handPrice: function () {
      return toNumber(this.item.arrive_hand_price || this.item.handPrice, 0)
    },
    retailPrice: function () {
      return toNumber(this.item.marker_price || this.item.retailPrice, 0)
    },
    grossMargin: function () {
      return toNumber(this.item.mao_lv || this.item.grossMargin, 0)
    },
    expirationDate: function () {
      return this.item.expiration_date || this.item.expirationDate || ''
    },
    jianzhuang: function () {
      return this.item.jianzhuang || this.item.boxQuantity || ''
    },
    packages: function () {
      return this.item.packages || this.item.middlePackage || ''
    },
    stockRaw: function () {
      return this.item.goods_number !== undefined &&
      this.item.goods_number !== null &&
      this.item.goods_number !== ''
        ? this.item.goods_number
        : this.item.stock
    },

    stock: function () {
      var raw = this.stockRaw

      if (typeof raw === 'number') {
        return raw
      }

      if (/^\d+(\.\d+)?$/.test(String(raw))) {
        return Number(raw)
      }

      return raw
    },

    stockText: function () {
      var stock = this.stock

      if (typeof stock === 'number') {
        return stock > 0 ? stock : '0'
      }

      return stock || '0'
    },
    limit: function () {
      return toNumber(this.item.limit, -1)
    },
    limitLabel: function () {
      return this.item.limit_lb || this.item.limitLabel || ''
    },
    promoLimit: function () {
      return toNumber(this.item.limit_pro || this.item.promoLimit, 0)
    },
    minBuy: function () {
      const explicit = toNumber(this.item.min_buy || this.item.minBuy, 0)
      if (explicit > 0) return explicit
      // 没有显式最低购买量时，默认使用步长值
      const step = toNumber(this.item.add_change || this.item.step, 1)
      return step > 0 ? step : 1
    },
    quantityStep: function () {
      const val = toNumber(this.item.add_change || this.item.step, 1)
      return val > 0 ? val : 1
    },
    maxQuantity: function () {
      const stockMax = Math.max(this.minBuy, this.stock)
      if (this.limit > 0) return Math.min(this.limit, stockMax)
      return stockMax
    },
    isSoldOut() {
      const stock = this.item.goods_number

      if (stock === 0 || stock === '0') {
        return true
      }

      if (typeof stock === 'number') {
        return stock <= 0
      }

      return false
    },
    cartDisabled: function () {
      return this.isSoldOut || this.showSoldOutMask || this.limit === 0
    },
    showFavorite: function () {
      return this.visible.favorite !== false
    },
    showSoldOutMask: function () {
      return this.visible.soldOutMask !== false && this.isSoldOut
    },
    showRetailProfit: function () {
      return this.visible.retailProfit !== false && (this.retailPrice > 0 || this.grossMargin > 0)
    },
    showDrugTags: function () {
      return this.visible.drugTags !== false
    },
    showStockInfo: function () {
      return this.visible.stockInfo !== false
    },
    showLimitInfo: function () {
      return this.visible.limitInfo !== false && (this.limit > 0 || this.promoLimit > 0)
    },
    showCardActivityTags: function () {
      return this.visible.cardActivityTags !== false
    },
    hasSpecialPriceActivity: function () {
      // label 1=特价, 7=新人特价, 5=阶梯价
      var codes = this.labelCodes
      if (codes.indexOf('1') > -1 || codes.indexOf('7') > -1 || codes.indexOf('5') > -1) {
        return true
      }
      if (this.hasSpecial) return true
      if (this.ladderMessages.length > 0) return true
      return false
    },
    labelCodes: function () {
      return asArray(this.item.lables || this.item.labels)
    },
    labelTexts: function () {
      const labelSet = this.goodsLabelSet || DEFAULT_LABEL_SET
      return this.labelCodes.map(function (code) {
        return labelSet[code] || code
      }).filter(Boolean)
    },
    hasSwap: function () {
      return this.swapMessages.length > 0 || this.labelCodes.indexOf('3') > -1 || this.labelTexts.indexOf('换购') > -1 || this.item.has_swap || this.item.hasSwap
    },
    hasSpecial: function () {
      return Boolean(this.item.is_special || this.item.isSpecial || this.promoLimit > 0 || this.labelCodes.indexOf('1') > -1 || this.labelTexts.indexOf('特价') > -1)
    },
    showSwapImageTag: function () {
      return this.visible.swapImageTag !== false && this.hasSwap
    },
    showSpecialImageTag: function () {
      return this.visible.specialImageTag !== false && this.hasSpecial
    },
    happyBean: function () {
      return toNumber(this.item.happy_bean || this.item.happyBean, 0)
    },
    showHappyBean: function () {
      return this.visible.happyBean !== false && this.happyBean > 0
    },
    fenceId: function () {
      return this.item.fence_id || this.item.fenceId || ''
    },
    fenceBase: function () {
      return this.item.fence_base || this.item.fenceBase || ''
    },
    showFence: function () {
      return this.visible.fence !== false && Boolean(this.item.is_fence || this.item.isFence) && Boolean(this.fenceId)
    },
    drugTags: function () {
      const tags = []
      if (this.item.is_yb || this.item.isYb) tags.push({ text: '医保', type: 'blue' })
      if (this.item.code_state && this.item.code_state !== '无') tags.push({ text: this.item.code_state, type: 'blue' })
      if (this.item.codeState && this.item.codeState !== '无') tags.push({ text: this.item.codeState, type: 'blue' })

      const chuffl = this.item.chuffl || ''
      if (chuffl === 'RX单轨制' || chuffl === 'RX双轨制' || chuffl === 'Rx') tags.push({ text: 'Rx', type: 'black' })
      if (chuffl === 'OTC甲类') tags.push({ text: 'OTC甲', type: 'red' })
      if (chuffl === 'OTC乙类') tags.push({ text: 'OTC乙', type: 'green' })

      return tags
    },
    ladderMessages: function () {
      return asArray(this.item.ladder_msg || this.item.ladderMessages)
    },
    swapMessages: function () {
      const buySwap = this.item.buy_swap_msg || this.item.buySwapMsg || {}
      return asArray(buySwap.msg || this.item.swapMessages)
    },
    freeGiftMessages: function () {
      return asArray(this.item.free_msg || this.item.freeMsg || this.item.freeGift)
    },
    seckillMessages: function () {
      return asArray(this.item.skill_msg || this.item.seckillMsg || this.item.seckillMessages)
    },
    cardActivityTags: function () {
      // 存在特价类活动时，卡片底部统一只显示一个"特价"标签
      // 但如果同时存在换购，也需要显示换购标签
      if (this.hasSpecialPriceActivity) {
        const tags = [{ text: '特价', type: 'red' }]
        // 检查是否同时有换购活动
        if (this.labelCodes.indexOf('3') > -1 || this.swapMessages.length > 0 || this.labelTexts.indexOf('换购') > -1) {
          tags.push({ text: '换购', type: 'orange' })
        }
        return tags
      }

      const tags = []

      const pushTag = function (text, type) {
        if (!text) return
        tags.push({
          text: text,
          type: type || 'red'
        })
      }

      const customTags = asArray(this.item.activity_tags || this.item.activityTags)
      customTags.forEach(function (text) {
        pushTag(text, 'red')
      })

      this.labelTexts.forEach(function (text) {
        if (!text) return

        if (text === '特价') {
          pushTag('特价', 'red')
          return
        }

        if (text === '换购') {
          pushTag('换购', 'orange')
          return
        }

        if (text === '赠送') {
          pushTag('赠送', 'green')
          return
        }

        if (text === '阶梯') {
          pushTag('阶梯价', 'red')
          return
        }

        if (text === '满赠') {
          pushTag('满赠', 'green')
          return
        }

        if (text === '秒杀') {
          pushTag('秒杀', 'red')
          return
        }

        pushTag(text, 'orange')
      })

      if (this.hasSpecial) {
        pushTag('特价', 'red')
      }

      if (this.hasSwap) {
        pushTag('换购', 'orange')
      }

      if (this.ladderMessages.length) {
        pushTag('阶梯价', 'red')
      }

      if (this.freeGiftMessages.length) {
        pushTag('满赠', 'green')
      }

      if (this.seckillMessages.length) {
        pushTag('秒杀', 'red')
      }

      if ((this.item.is_chang === 1 || this.item.isCommonBuy) && this.visible.commonBuy !== false) {
        pushTag('常购', 'green')
      }

      const unique = []
      const map = {}

      tags.forEach(function (tag) {
        if (!map[tag.text]) {
          map[tag.text] = true
          unique.push(tag)
        }
      })

      return unique
    },
    activityDetails: function () {
      const list = []
      if (this.visible.ladderDetail !== false && this.ladderMessages.length) {
        list.push({ title: '阶梯价', lines: this.ladderMessages })
      }
      if (this.visible.swapDetail !== false && this.swapMessages.length) {
        list.push({ title: '换购信息', lines: this.swapMessages })
      }
      if (this.visible.freeGiftDetail !== false && this.freeGiftMessages.length) {
        list.push({ title: '满赠 / 包邮', lines: this.freeGiftMessages })
      }
      if (this.visible.seckillDetail !== false && this.seckillMessages.length) {
        list.push({ title: '秒杀活动', lines: this.seckillMessages })
      }
      return list
    }
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler: function () {
        this.localQuantity = this.normalizeQuantity(this.item.add_init || this.item.quantity || this.minBuy)
        this.localFavorite = Number(this.item.is_favorites) === 1 || Boolean(this.item.isFavorite)
        this.brokenImage = false
      }
    }
  },
  methods: {
    formatMoney: function (value) {
      return Number(value || 0).toFixed(2)
    },
    onImageError: function () {
      this.brokenImage = true
    },
    normalizeQuantity: function (value) {
      let quantity = toNumber(value, this.minBuy)
      if (quantity < this.minBuy) quantity = this.minBuy
      if (this.maxQuantity > 0 && quantity > this.maxQuantity) quantity = this.maxQuantity
      return quantity
    },
    addQuantity: function () {
      this.changeQuantity(Number(this.localQuantity) + this.quantityStep)
    },
    reduceQuantity: function () {
      this.changeQuantity(Number(this.localQuantity) - this.quantityStep)
    },
    onQuantityInput: function (event) {
      this.localQuantity = event.target.value
    },
    validateQuantity: function () {
      this.changeQuantity(Number(this.localQuantity))
    },
    changeQuantity: function (nextValue) {
      let quantity = toNumber(nextValue, this.minBuy)
      let message = ''
      if (quantity < this.minBuy) {
        quantity = this.minBuy
        message = '购买量不能低于最低购买量'
      }
      if (this.maxQuantity > 0 && quantity > this.maxQuantity) {
        quantity = this.maxQuantity
        message = this.limit > 0 && this.limit <= this.stock ? '购买量超过限购数量' : '购买量超过库存'
      }
      if (this.promoLimit > 0 && quantity > this.promoLimit) {
        message = '超过特价限购部分按正常价计算'
      }
      this.localQuantity = quantity
      this.$emit('quantity-change', { item: this.item, quantity: quantity })
      if (message) this.notify(message, 'warning')
    },
    handleFavorite: function () {
      this.localFavorite = !this.localFavorite
      this.$emit('favorite-change', {
        item: this.item,
        isFavorite: this.localFavorite,
        type: this.localFavorite ? 1 : 2
      })
      this.notify(this.localFavorite ? '已收藏该商品' : '已取消收藏', 'success')
    },
    handleAddCart: function () {
      if (this.cartDisabled) {
        this.notify('当前商品暂不可购买', 'warning')
        return
      }
      const payload = {
        item: this.item,
        goods_id: this.goodsId,
        quantity: Number(this.localQuantity),
        goods_label: this.item.lables || this.item.labels || '',
        selling_price: this.displayPrice,
        original_price: this.originalPrice
      }
      this.$emit('add-cart', payload)
      this.notify('已加入购物车', 'success')
    },
    handleDetail: function () {
      this.$emit('detail', this.item)
    },
    handlePreemptDetail: function () {
      this.$emit('preempt-detail', this.item)
    },
    shouldHighlightExpiration(tm) {
      if (!tm) return false;
      const targetDate = new Date(tm);
      const currentDate = new Date();

      // 如果效期在当前时间之前（已过期），标红
      if (targetDate <= currentDate) return true;

      // 计算距离当前时间的天数差
      const diffTime = targetDate.getTime() - currentDate.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 6个月约180天，小于180天标红
      return diffDays <= 180;
    },
    notify: function (message, type) {
      // this.$emit('message', { type: type, message: message })
      // const vm = this
      // const handler = vm.$message || vm.$Message
      // if (!handler) return
      // if (typeof handler === 'function') {
      //   handler({ type: type, message: message })
      // } else if (handler[type]) {
      //   handler[type](message)
      // }

    }
  }
}
</script>

<style scoped>
.goods-info-card {
  --primary: #0aad48;
  --primary-dark: #07863a;
  --primary-soft: #e9fff2;
  --red: #ff313c;
  --orange: #ff8900;
  --text-main: #2f3236;
  --text-sub: #5f6265;
  --text-light: #8a8f94;
  --border: #edf0ee;
  --shadow: 0 10px 28px rgba(18, 52, 35, 0.12);
  width: 230px;
  position: relative;
  border-radius: 10px;
  color: var(--text-main);
  font-family: PingFang SC, Microsoft YaHei, Roboto, Helvetica Neue, Arial, sans-serif;
  overflow: visible;
}

.goods-card-main {
  position: relative;
  z-index: 10;
  min-height: 502px;
  padding: 30px 16px 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.goods-info-card:hover .goods-card-main {
  transform: translateY(-3px);
  border-color: rgba(10, 173, 72, 0.28);
  box-shadow: var(--shadow);
}

.activity-image-tags {
  position: absolute;
  top: -8px;
  left: 8px;
  z-index: 18;
  display: flex;
  align-items: flex-start;
  gap: 2px;
  pointer-events: none;
}

.activity-image-tag {
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.12));
}

.tag-swap {
  width: 180px;
  height: auto;
}

.tag-special {
  width: 180px;
  height: auto;
  margin-top: 1px;
}

.favorite-btn {
  position: absolute;
  top: 9px;
  right: 10px;
  z-index: 70;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  color: #b8bfc4;
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;

  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.16s ease, visibility 0.16s ease, transform 0.16s ease;
}

.goods-info-card:hover .favorite-btn {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.favorite-btn.active {
  color: #ff313c;
}

.goods-image {
  width: 188px;
  height: 188px;
  margin: 0 auto;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(145deg, #f5f8f6, #fff);
  cursor: pointer;
}

.goods-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.goods-image-placeholder {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  color: #a1aaa4;
  font-size: 14px;
  background:
    radial-gradient(circle at 30% 25%, rgba(10, 173, 72, 0.16), transparent 34%),
    linear-gradient(135deg, #f8fbf9, #eef6f1);
}

.retail-profit-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 5;
  width: 100%;
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 0 8px;
  border-radius: 9px 9px 0 0;
  background: linear-gradient(270deg, rgba(255, 66, 96, 0.92), rgba(233, 168, 58, 0.92));
  color: #fff;
  font-size: 10px;
  white-space: nowrap;
}

.soldout-mask {
  width: 180px;
  height: 184px;
  max-width: 180px;
  max-height: 180px;
  margin: 0 auto;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(35, 37, 37, .6);
  img{
    width: 112px;
    height: 112px;
    margin: 34px;
  }
}

.price-row {
  display: flex;
  align-items: baseline;
  gap: 3px;
  margin-top: 11px;
  min-height: 28px;
  flex-wrap: wrap;
}

.price {
  color: #fa0000;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.price small {
  font-size: 14px;
  margin-right: 1px;
}

.unit,
.old-price {
  font-size: 12px;
  color: var(--text-light);
}

.hand-price-line {
  color: #fa0000;
}

.hand-price-label {
  font-size: 14px;
  font-weight: 500;
}

.hand-price-value {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.hand-price-value small {
  font-size: 14px;
  margin-right: 1px;
}

.hand-price-unit {
  font-size: 14px;
}

.hand-price {
  margin-left: 4px;
  color: #fa0000;
}

.old-price {
  text-decoration: line-through;
}

.goods-name {
  margin: 6px 0 0;
  height: 42px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  color: #111;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.goods-name:hover {
  color: var(--primary-dark);
}

.drug-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  min-height: 20px;
  margin-top: 8px;
}

.drug-tag {
  height: 18px;
  padding: 0 4px;
  border: 1px solid currentColor;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}

.drug-tag.blue { color: #154bff; }
.drug-tag.black { color: #111; }
.drug-tag.red { color: #ff0000; }
.drug-tag.green { color: #2bc240; }

.manufacturer,
.spec {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 18px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.spec {
  color: var(--text-sub);
}

.meta-block {
  margin-top: 8px;
}

.meta-row {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-top: 7px;
  color: #666;
  font-size: 12px;
  line-height: 16px;
}

.danger {
  color: #fa0000;
}

.limit-row {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  min-height: 18px;
  margin-top: 8px;
  color: var(--primary-dark);
  font-size: 12px;
}
.card-activity-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 24px;
  margin-top: 9px;
}

.card-activity-tag {
  height: 20px;
  padding: 0 7px;
  border: 1px solid #fa0000;
  border-radius: 3px;
  background: #fff;
  color: #fa0000;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
}

.card-activity-tag.red {
  border-color: #fa0000;
  color: #fa0000;
  background: #fff4f4;
}

.card-activity-tag.orange {
  border-color: #ff8900;
  color: #ff8900;
  background: #fff8ef;
}

.card-activity-tag.green {
  border-color: var(--primary);
  color: var(--primary-dark);
  background: var(--primary-soft);
}

.ladder-info-on-card {
  margin-top: 6px;
  padding: 6px 8px;
  background: #fff8ef;
  border-radius: 4px;
  border: 1px solid #ffe4c4;
}

.ladder-info-on-card p {
  margin: 2px 0;
  font-size: 12px;
  font-weight: bold;
  color: red;
  line-height: 1.4;
}

.operation-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
}

.qty-control {
  display: flex;
  width: 92px;
  height: 28px;
  border: 1px solid #e4e7e5;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.qty-control button {
  width: 26px;
  border: 0;
  background: #f8faf9;
  color: #53585c;
  cursor: pointer;
}

.qty-control input {
  width: 40px;
  border: 0;
  border-left: 1px solid #e4e7e5;
  border-right: 1px solid #e4e7e5;
  text-align: center;
  color: #333;
  outline: none;
}

.qty-control input::-webkit-inner-spin-button,
.qty-control input::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.cart-btn {
  flex: 1;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: #ff1a18;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(176, 2, 0, 0.2);
}

.cart-btn:disabled {
  cursor: not-allowed;
  background: #c9ced1;
  box-shadow: none;
}

.activity-popover {
  position: absolute;
  left: calc(100% + 12px);
  top: 16px;
  z-index: 50;
  width: 260px;
  padding: 14px;
  border: 1px solid rgba(10, 173, 72, 0.16);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(12, 44, 27, 0.16);
  opacity: 0;
  visibility: hidden;
  transform: translateX(-6px);
  transition: opacity 0.16s ease, visibility 0.16s ease, transform 0.16s ease;
  pointer-events: none;
}

.activity-popover::before {
  content: "";
  position: absolute;
  left: -7px;
  top: 28px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid rgba(10, 173, 72, 0.16);
  border-bottom: 1px solid rgba(10, 173, 72, 0.16);
  transform: rotate(45deg);
}

.goods-info-card:hover .activity-popover {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.popover-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #edf0ee;
  color: var(--primary-dark);
  font-size: 18px;
  font-weight: 700;
}

.popover-section {
  margin-top: 10px;
}

.popover-section h4 {
  margin: 0 0 6px;
  color: #111;
  font-size: 22px;
}

.popover-section p {
  margin: 5px 0 0;
  color: var(--text-sub);
  font-size: 16px;
  line-height: 1.5;
}

/* 原商品列表展示逻辑：玩乐豆 */
.happy_bean_goods {
  width: 100%;
  height: 223px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 14;
  cursor: pointer;
  pointer-events: auto;
}

.happy_bean_num {
  font-size: 20px;
  font-weight: 700;
  color: #ff0010;
  position: absolute;
  top: 108px;
  right: 8px;
  z-index: 15;
  cursor: pointer;
}

/* 原商品列表展示逻辑：占山头 / 电子围栏 */
.fence_goods {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 60;
  cursor: pointer;
}

.fence_goods_base {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  position: absolute;
  bottom: 7px;
  right: 48px;
  z-index: 61;
  cursor: pointer;
  max-width: 128px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .activity-popover {
    left: 0;
    top: calc(100% + 10px);
    width: 100%;
    transform: translateY(-4px);
  }

  .activity-popover::before {
    left: 28px;
    top: -7px;
    transform: rotate(135deg);
  }

  .goods-info-card:hover .activity-popover {
    transform: translateY(0);
  }
}
.goods-info-card {
  width: 200px;
}

.goods-card-main {
  min-height: 502px;
  padding: 30px 12px 16px;
}

.goods-image {
  width: 164px;
  height: 164px;
}

.soldout-mask {
  width: 164px;
  height: 164px;
}

.soldout-mask img {
  width: 100px;
  height: 100px;
  margin: 32px;
}

.tag-swap,
.tag-special {
  width: 150px;
}

.price {
  font-size: 20px;
}

.goods-name {
  font-size: 14px;
  line-height: 20px;
}

.manufacturer,
.spec {
  font-size: 12px;
}

.meta-row {
  font-size: 11px;
}

.operation-row {
  gap: 5px;
}

.qty-control {
  width: 78px;
}

.qty-control button {
  width: 22px;
}

.qty-control input {
  width: 34px;
}

.cart-btn {
  font-size: 12px;
}
.activity-popover {
  width: 230px;
}

.popover-title {
  font-size: 16px;
}

.popover-section h4 {
  font-size: 18px;
}

.popover-section p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsInfoCard/GoodsInfoCardForSim.vue